<template>
  <div>
    <module v-for="(module, code) in modules"
            :key="`${code}-module`"
            :title="module.title"
            :code="code"
            :copy="module.copy"
            :submodules="module.submodules" />
  </div>
</template>

<script>
import { getModules } from '@/utils/api';
import Module from '@/components/members/Module';

export default {
  components: {
    Module
  },
  data() {
    return {
      modules: {}
    }
  },
  mounted() {
    getModules()
      .then(async res => {
        if (!res.ok) {

          this.$buefy.toast.open({
            message: 'Login',
            type: 'is-danger'
          });

          return this.$router.push({path: '/login', query: this.$route.query});
        }

        let data = await res.json();
        this.modules = data.modules;
      })
  }
}
</script>